import { Box } from '@mui/material';
import { StyledTab, StyledTabs } from './StyleSlectCat';
import { useEffect, useState } from 'react';
import Image from 'next/image';
import AllIcon from 'common/assets/image/logo/icon/allIcon';
import ChatIcon from 'common/assets/image/logo/icon/ChatIcon';
import DocsIcon from 'common/assets/image/logo/icon/DocsIcon';
import CodeIcon from 'common/assets/image/logo/icon/CodeIcon';
import VideoIcon from 'common/assets/image/logo/icon/videoIcon';
import ImageIcon from 'common/assets/image/logo/icon/ImageIcon';
import AudioIcon from 'common/assets/image/logo/icon/AudioIcon';
import GptIcon from 'common/assets/image/logo/icon/GptIcon';
import WebIcon from 'common/assets/image/logo/icon/WebIcon';
const SelectCategory = ({ bots, handleChange }) => {
  const [value, setValue] = useState(3);
  const onChanges = (newValue) => {
    setValue(newValue);
  };
  
  useEffect(() => {
    if (bots?.length > 0) {
      handleChange(bots[3].bots); 
    }
  }, [bots]);
  const getCategoryIcon = (tag_slug) => {
    switch (tag_slug) {
      case 'popular':
        return <AllIcon />;
      case 'aichat':
        return <ChatIcon />;
      case 'document':
        return <DocsIcon />;
      case 'image':
        return <ImageIcon />;
      case 'video':
        return <VideoIcon />;
      case 'code':
        return <CodeIcon />;
      case 'audio':
        return <AudioIcon />;
      case 'gpt':
        return <GptIcon />;
      case 'web':
        return <WebIcon />;
      default:
        return null;
    }
  };
  return (
    <Box sx={{ display: 'flex', flexDirection: 'row' }}>
      <StyledTabs
        variant="scrollable"
        scrollButtons="auto"
        aria-label="category tabs"
        value={value}
        onChange={(event, newValue) => onChanges(newValue)} 
      >
        {bots?.map(
          (category, index) =>
            category.bots && category.bots.length > 0 ? (
              <StyledTab color=''
                value={index}
                key={index}
                onClick={() => handleChange(category.bots)}
                icon={getCategoryIcon(category.tag_slug)}
                label={category.tag_slug}
                iconPosition="top"
              />
            ) : null, 
        )}
      </StyledTabs>
    </Box>
  );
};

export default SelectCategory;
